import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import { Box } from '@endpoint/blockparty';
import { AlertMessage } from 'components/AlertMessage';
import { TRANSACTION } from 'consts/routes';
import { TransactionSkeleton } from 'components/Skeleton';
import { useGetClosedTransactions } from 'hooks/useGetClosedTransactions';

import { NoTransactions } from '../NoTransactions';
import { TransactionCard } from '../TransactionCard';
import { TransactionGrid } from '../TransactionGrid';

export const Closed: FC = () => {
  const { data, loading, error } = useGetClosedTransactions();
  const hasNoTransactions = data?.myTransactions.length === 0 || data?.myTransactions === null;

  if (loading) {
    return (
      <TransactionGrid>
        <TransactionSkeleton />
      </TransactionGrid>
    );
  }

  if (error) {
    return (
      <Box m="space50">
        <AlertMessage>Cannot load Closed transactions</AlertMessage>
      </Box>
    );
  }

  if (hasNoTransactions) {
    return (
      <NoTransactions
        description="Once a transaction has closed, it will appear here."
        title="There are no closed transactions"
      />
    );
  }

  return (
    <TransactionGrid>
      {data?.myTransactions.map((transaction) => {
        const LinkTo = { as: Link, to: `/${TRANSACTION}/${transaction.id}/todos` };

        return (
          <Box key={transaction.id} bg="background" textDecoration="none" width="100%" {...LinkTo}>
            <TransactionCard {...transaction} />
          </Box>
        );
      })}
    </TransactionGrid>
  );
};
